import api from './api';

export const listContent = (sequenceType) =>
  api.get(`/admin/sequence-content/${sequenceType}`).then(r => r.data.content);

export const createContent = (sequenceType, fields) =>
  api.post(`/admin/sequence-content/${sequenceType}`, fields).then(r => r.data.content);

export const updateContent = (id, fields) =>
  api.put(`/admin/sequence-content/item/${id}`, fields).then(r => r.data.content);

export const deleteContent = (id) =>
  api.delete(`/admin/sequence-content/item/${id}`);

export const bulkImportContent = (sequenceType, csvText) =>
  api.post(`/admin/sequence-content/${sequenceType}/bulk-import`, { csv: csvText }).then(r => r.data);

export const bulkCreateContent = (sequenceType, rows) =>
  api.post(`/admin/sequence-content/${sequenceType}/bulk-import`, { rows }).then(r => r.data);

/** One sheet, both Daily emails and Hub Announcements — reads Email* columns into Daily, Hub* columns into Announcements. */
export const bulkImportCombined = (csvText) =>
  api.post('/admin/content-pushes/bulk-import-combined', { csv: csvText }).then(r => r.data);

/** Alt text already saved for this exact picture, if it's been used before. */
export const getSavedImageAltText = (imageUrl) =>
  api.get('/admin/image-alt-text', { params: { url: imageUrl } }).then(r => r.data.alt_text);

/** The exact HTML the daily dispatch job would send for this content — real preview, not the generic layout. */
export const getEmailPreviewHtml = (id) =>
  api.get(`/admin/sequence-content/item/${id}/email-preview`, { responseType: 'text' }).then(r => r.data);

/** Same real preview, for a row that hasn't been saved yet. */
export const getDraftEmailPreviewHtml = (draft) =>
  api.post('/admin/sequence-content/email-preview-draft', draft, { responseType: 'text' }).then(r => r.data);

/** Sends the real rendered email to a real inbox — no member or live system touched. */
export const sendTestEmail = (id, email) =>
  api.post(`/admin/sequence-content/item/${id}/send-test-email`, { email }).then(r => r.data);

/** Same real test send, for a row that hasn't been saved yet. */
export const sendTestEmailDraft = (draft) =>
  api.post('/admin/sequence-content/send-test-email-draft', draft).then(r => r.data);

/** Quiz follow-up emails: Jenn's on/off switch and the list of who took the quiz. */
export const getQuizSettings = () =>
  api.get('/admin/sequence-content/quiz/settings').then(r => r.data);

export const setQuizSettings = (sending) =>
  api.put('/admin/sequence-content/quiz/settings', { sending }).then(r => r.data);

export const listQuizTakers = () =>
  api.get('/admin/sequence-content/quiz/takers').then(r => r.data);
